function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M394.667,449.963v-80.576c0-27.669-11.947-54.016-32.789-72.256L314.859,256l47.019-41.131 c20.843-18.24,32.789-44.587,32.789-72.256V62.037C407.061,57.621,416,45.888,416,32c0-17.643-14.357-32-32-32H128 c-17.643,0-32,14.357-32,32c0,13.888,8.939,25.621,21.333,30.037v80.576c0,27.669,11.947,54.016,32.789,72.256L197.141,256 l-47.019,41.131c-20.843,18.24-32.789,44.587-32.789,72.256v80.576C104.939,454.379,96,466.112,96,480c0,17.643,14.357,32,32,32 h256c17.643,0,32-14.357,32-32C416,466.112,407.061,454.379,394.667,449.963z M373.333,448H138.667v-78.613 c0-21.525,9.301-42.005,25.493-56.192l56.192-49.173c2.325-2.027,3.648-4.949,3.648-8.021s-1.323-5.995-3.648-8.021 l-56.192-49.173c-16.192-14.187-25.493-34.667-25.493-56.192V64h234.667v78.613c0,21.525-9.301,42.005-25.493,56.192 l-56.192,49.173C289.323,250.005,288,252.928,288,256s1.323,5.995,3.648,8.021l56.192,49.173 c16.213,14.187,25.493,34.667,25.493,56.192V448z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M349.675,409.344l-85.333-106.667c-4.053-5.056-12.608-5.056-16.661,0l-85.333,106.667c-2.56,3.2-3.051,7.595-1.28,11.285 c1.771,3.691,5.504,6.037,9.6,6.037h170.667c4.096,0,7.829-2.347,9.621-6.037C352.725,416.939,352.235,412.544,349.675,409.344z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M308.523,177.259c-1.643-3.989-5.547-6.592-9.856-6.592h-85.333c-4.309,0-8.213,2.603-9.856,6.592 c-1.664,3.989-0.747,8.555,2.304,11.627l42.667,42.667c2.091,2.069,4.821,3.115,7.552,3.115s5.461-1.045,7.552-3.115 l42.667-42.667C309.269,185.835,310.187,181.248,308.523,177.259z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

function SvgUpcoming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.7b60e6ce.svg";
export { ForwardRef as ReactComponent };